import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-196" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-197" data-mp="30j0wlgv3h18d">
        <div className="text-center" data-id="element-198" data-mp="2vpg2hzwmgreg">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-199" data-mp="2voehb2lw6oj0">
            ¿Te suena conocido esto?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-silver-100" data-id="element-200" data-mp="35fixu6r7uhfy">
            Domingo a las 11 de la noche. Mañana tienes clase de criminalística. Y todavía estás buscando cómo explicar
            la diferencia entre el lugar de los hechos y las disciplinas forenses, cómo funcionan los análisis de ADN o
            por qué la cadena de custodia es importante sin que tus alumnos se duerman o no entiendan nada.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-silver-300" data-id="element-201" data-mp="jddecdssymy6">
            No es tu culpa. Es que llevas años peleando con materiales desorganizados, teoría densa en libros viejos y
            recursos pensados para otros contextos que después tienes que reescribir entero.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-silver-400/25 bg-navy-900 p-6 shadow-sm shadow-black/20 sm:p-8" data-id="element-202" data-mp="x4rxqlqmgq5r">
          <p className="mb-5 inline-flex items-center gap-2 font-serif text-xl font-bold tracking-tight text-white" data-id="element-203" data-mp="1c2kbp9git6hu">
            <AlertTriangleIcon className="h-5 w-5 text-silver-300" aria-hidden="true" data-id="element-204" data-mp="1g11kryji4r1w" />
            El costo de no tener el material correcto:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-205" data-mp="3hvse0rxat7me">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-silver-100" data-id="element-206" data-mp="ozh6ukkx1iqd">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-500" aria-hidden="true" data-id="element-207" data-mp="k1z5pgd547sx" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-208" data-mp="tz3ttlqjqdcd">
          <p className="text-lg font-bold text-silver-200" data-id="element-209" data-mp="ty26ahscfydr">
            Basta de regalar tu tiempo libre. Tu dedicación ya la tienes. Ahora te falta la herramienta.
          </p>
          <p className="mt-3 font-serif text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-210" data-mp="12z8qb0u7brbr">
            Planifica todo tu año{' '}
            <span className="text-silver-200 underline decoration-silver-300 decoration-4 underline-offset-4" data-id="element-211" data-mp="1cpuzac7exjlh">hoy.</span>
          </p>
        </div>
      </div>
    </section>;
}